import * as React from 'react';
import { Button, Divider, Dropdown, Form, Input, MenuProps, ModalProps, Radio, RadioChangeEvent, Select, Space, List, Avatar, Modal, Checkbox, notification, Empty } from 'antd';
import CustomModal from '../../../components/Modal/CustomModal';
import { DownOutlined } from '@ant-design/icons';
import Search from 'antd/lib/input/Search';
import './index.scss';
import { useDispatch } from 'react-redux';
import { getData } from '../../../actions/apiCall';
import RenderFormItem from '../../../components/Forms/FormItems';
import InfiniteScrollList from '../../../components/Forms/ListView/InfiniteScrollList';
import IssueComponent from '../../projects/dashboard/tasks/issueComponent';
import { postData, putData } from '../../../actions/developer';
import { getBrowserDetails, getIPAddress, getLocation } from '../../../actions/auth';
const { useForm } = Form;
const { useState, useEffect, useCallback } = React;
const { Option } = Select;

interface CustomModalProps extends ModalProps {
    onConfirm?: () => void;
    onCancel?: () => void;
    attendance?: any;
}

const TaskManagement: React.FC<CustomModalProps> = ({
    open,
    onConfirm,
    onCancel,
    attendance,
}) => {
    const [form] = useForm();
    const [status, setStatus] = useState<string | null>(null);
    const [projects, setProjects] = useState<any[]>([]);
    const [projectId, setProjectId] = useState<string>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [items, setColumns] = useState<any[]>([]);
    const [selectedTask, setSelectedTask] = useState<any>(null);
    const [openCreate, setOpenCreate] = useState<boolean>(false);
    const [taskDetails, setTaskDetails] = useState<string>('');
    const [activeSprint, setActiveSprint] = useState<any>(null);
    const [todaysTask, setTodaysTask] = useState<any[]>([]);
    const [uploadingTask, starUploadingTask] = useState<boolean>(false);
    const [attendanceId, setAttendanceId] = useState<string>(attendance);

    const disptach = useDispatch();

    const getCurrentStatus = async () => {
        const resData = await disptach(getData('/attendance-logs'))
        if (resData) {
            setAttendanceId(resData.data)
        }
    }

    React.useEffect(() => {
        getCurrentStatus()
    }, []);

    React.useEffect(() => {
        if (open) {
            getProjects();
        }
    }, [open]);

    // Note: Socket listener moved to Navbar component for global access

    React.useEffect(() => {
        if (projectId) {
            setLoading(true);
            getColumns(projectId);
            getActiveSprint();
        }
    }, [projectId]);

    const getProjects = async () => {
        try {
            const resData = await disptach(getData('/projects/my/list'));
            if (resData.code == 200) {
                setProjects(resData.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getActiveSprint = async () => {
        try {
            const resData = await disptach(getData(`/projects/my/active/sprint/${projectId}`));
            if (resData.code == 200) {
                setActiveSprint(resData.data);
            }
        } catch (error) {
            console.log(error);
        }
    }


    const getColumns = async (projectId: string) => {
        try {
            const resData = await disptach(getData(`/columns/${projectId}`));
            if (resData.code == 200) {
                const data = resData.data.map((item: any) => { return { ...item, label: <div className={`text-[${item?.color}]`}>{item?.name}</div>, key: item._id } })
                setColumns(data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const onCreateTask = async () => {
        try {
            if (!taskDetails) {
                notification.error({ message: 'Task details is required' });
                return
            };
            if (!activeSprint) {
                notification.error({ message: 'No active sprint found' });
                return
            };
            if (!projectId) {
                notification.error({ message: 'Project is required' });
                return
            };

            if (attendanceId) {
                const payload = {
                    projectId: projectId,
                    columnId: status ? items.find((item) => item.key === status)?._id : items[0]._id,
                    sprintId: activeSprint._id,
                    title: taskDetails,
                    order: 0
                }
                const resData = await disptach(postData('/tasks/my/timesheet/individual/start', payload));
                if (resData.code == 200) {
                    setOpenCreate(false);
                    setTaskDetails('');
                    setLoading(true);
                }
            } else {
                const resData = await disptach(postData('/projects/my/tasks', {
                    columnId: status ? items.find((item) => item.key === status)?._id : items[0]._id,
                    sprintId: activeSprint._id,
                    projectId: projectId,
                    title: taskDetails,
                    order: 0
                }));
                if (resData.code == 200) {
                    setOpenCreate(false);
                    setTaskDetails('');
                    setLoading(true);
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    const onChangeStatus = async (columnId: string, taskId: string) => {
        try {
            const resData = await disptach(putData(`/tasks/${taskId}`, { columnId }));
            if (resData) {
                setLoading(true);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const onClose = () => {
        setSelectedTask(null);
        setLoading(true);
        setProjectId(null);
        setTodaysTask([]);
        onConfirm();
    }

    const onSave = async () => {
        if (todaysTask.length == 0) {
            notification.error({ message: 'Please select a task to work on for the whole day' });
        } else {
            starUploadingTask(true);
            try {
                const ipAddress = await getIPAddress();
                const location = await getLocation();
                const browserDetails = getBrowserDetails();
                const payload = {
                    tasks: todaysTask,
                    projectId: projectId,
                    ipAddress,
                    latitude: location.latitude,
                    longitude: location.longitude,
                    platform: browserDetails.platform,
                    userAgent: browserDetails.userAgent
                }
                const resData = await disptach(postData('/tasks/my/timesheet/start', payload));
                if (resData.code == 200) {
                    onClose();
                    // Socket event will trigger target fetch, no need to call directly
                } else {
                    notification.error({ message: resData.message });
                }
            } catch (error) {
                console.log(error);
                notification.error({ message: 'An error occured' });
            } finally {
                starUploadingTask(false);
            }
        }
    }

    const onSubmit = async (values: any) => {
        try {
            starUploadingTask(true);
            const ipAddress = await getIPAddress();
            const location = await getLocation();
            const browserDetails = getBrowserDetails();
            const payload = {
                tasks: Object.entries(values).map(([key, value]) => {
                    return {
                        id: key, comment: value,
                        startOn: attendance.startDate
                    }
                }),
                attendanceId: attendance._id,
                attendanceStartDate: attendance.startDate,
                ipAddress,
                latitude: location.latitude,
                longitude: location.longitude,
                platform: browserDetails.platform,
                userAgent: browserDetails.userAgent
            }

            const resData = await disptach(putData('/tasks/my/timesheet/end', payload));
            if (resData) {
                onClose();
            } else {
                notification.error({ message: resData.message });
            }
        } catch (error) {
            console.log(error);
            notification.error({ message: 'An error occured' });
        } finally {
            starUploadingTask(false);
        }
    }

    const onUpdate = async () => {
        try {
            form.submit();
        } catch (error) {
            console.log(error);
        }
    }

    const handleMenuClick: MenuProps['onClick'] = (e) => {
        setStatus(e.key);
    };

    React.useEffect(() => {
        if (status) {
            setLoading(true);
        }
    }, [status]);

    const menuProps = {
        items,
        onClick: handleMenuClick,
    };

    return (
        <div>
            <CustomModal
                title="Task Management"
                open={open}
                onConfirm={() => attendance ? onUpdate() : onSave()}
                onCancel={onCancel}
                width={'60%'}
                onloading={uploadingTask}
                maskClosable={false}
            >
                <div className="mt-4">
                    <div className='max-w-[250px]'>
                        <RenderFormItem
                            column={{
                                name: 'project',
                                type: 'select',
                                isCombo: true,
                                selectProps: {
                                    allowClear: true,
                                    onChange: (value: any) => {
                                        setProjectId(value)
                                    }
                                }
                            }}
                            combo={[{
                                name: 'project',
                                api: '/projects/my/list',
                                idKey: (e) => e?.projectId?._id,
                                render: (data: any) => data?.projectId?.name
                            }]}
                        />
                    </div>
                    {projectId ? <>
                        <div className='mt-4'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Space className="task_header_search" direction="horizontal" >
                                    <div>
                                        {/* <Search
                                    placeholder="Search names"
                                    value={searchValue}
                                    onChange={handleSearch}
                                /> */}
                                    </div>
                                    {items && items?.length > 0 && <Space direction="horizontal">
                                        <div>
                                            {activeSprint && <div className="text-black font-bold">
                                                {activeSprint?.name}
                                                {activeSprint?.startDate && <span className="text-gray-500"> ({new Date(activeSprint?.startDate).toLocaleDateString()} - {new Date(activeSprint?.endDate).toLocaleDateString()})</span>}
                                            </div>}
                                        </div>
                                        {!attendance && <Dropdown
                                            menu={menuProps}
                                        >
                                            <Button type="link">
                                                <Space>
                                                    {status ? <div className={`text-[${items?.find((item) => item.key === status)?.color}]`}>
                                                        {items?.find((item) => item.key === status)?.label}
                                                    </div>
                                                        : 'Status'}
                                                    <DownOutlined />
                                                </Space>
                                            </Button>
                                        </Dropdown>}
                                        <Button type="default" size="small" onClick={() => setOpenCreate(true)}>Create Task</Button>
                                    </Space>}
                                </Space>
                                <div>
                                    {openCreate && <div className="task_list my-4">
                                        <div className="task_list_item w-full">
                                            <div className="task_title text-black font-semibold w-full">
                                                <Input autoFocus placeholder="Type task details" onChange={(e) => setTaskDetails(e.target.value)} className='text-lg border-0 outline-0 border-b border-gray-200 rounded-none' />
                                            </div>
                                            <Space direction="horizontal" className="task_status">
                                                <div className="task_Priority text-blue-500">
                                                    <Button type="link" onClick={() => setOpenCreate(false)}>Cancel</Button>
                                                    <Button type="link" onClick={() => onCreateTask()}>Save</Button>
                                                </div>
                                            </Space>
                                        </div>
                                    </div>}
                                    <InfiniteScrollList
                                        apiUrl={attendanceId ? `/tasks/my/timesheet/inprogress` : `/projects/my/tasks/${projectId}`}
                                        apiQuery={{ columnId: status, andOr: 'and' }}
                                        itemsPerPage={14}
                                        reload={loading}
                                        onLoaded={() => setLoading(false)}
                                        renderItem={(item) => attendanceId ?
                                            <div className='flex items-center w-full space-x-4 p-2 border-b border-gray-200'>
                                                <Form
                                                    form={form}
                                                    onFinish={onSubmit}
                                                    className='w-full'
                                                >
                                                    <div className="task_list w-full">
                                                        <div className="task_list_item">
                                                            <div className="task_title text-black font-bold hover:underline cursor-pointer hover:text-blue-700" onClick={() => setSelectedTask(item?.taskId?._id)}>
                                                                {item?.taskId?.title}
                                                            </div>
                                                            <Space direction="horizontal" className="task_status">
                                                                <div className="task_Priority capitalize underline text-gray-500">
                                                                    {item?.taskId?.priority} Priority
                                                                </div>
                                                                <div>
                                                                    |
                                                                </div>
                                                                <Dropdown
                                                                    menu={{
                                                                        items: items,
                                                                        onClick: (e) => {
                                                                            console.log(e);
                                                                            onChangeStatus(e.key, item?.taskId?._id)
                                                                        }
                                                                    }}
                                                                >
                                                                    <Button type="link">
                                                                        <Space>
                                                                            <div className={`text-[${items?.find((_item) => _item.key === item?.taskId?.columnId)?.color}]`}>
                                                                                {items?.find((_item) => _item.key === item?.taskId?.columnId)?.label}
                                                                            </div>
                                                                            <DownOutlined />
                                                                        </Space>
                                                                    </Button>
                                                                </Dropdown>
                                                            </Space>
                                                        </div>
                                                        <div className="task_dis_view">
                                                            <div className="w-full text-gray-600 line-clamp-2" dangerouslySetInnerHTML={{ __html: item?.taskId?.description }} />
                                                        </div>
                                                        <div className='w-full'>
                                                            <Form.Item
                                                                rules={[{ required: true, message: 'Please enter work status' }]}
                                                                name={item?._id}
                                                            >
                                                                <Input.TextArea placeholder="Enter work satus" />
                                                            </Form.Item>
                                                        </div>
                                                    </div>
                                                </Form>
                                            </div>
                                            : <div className='flex items-center w-full space-x-4 p-2 border-b border-gray-200'>
                                                <div>
                                                    <Checkbox checked={todaysTask.includes(item._id)}
                                                        onChange={(e) => {
                                                            setTodaysTask(prev => !e.target.checked ? prev.filter(ele => ele != item?._id)
                                                                : [...prev, item?._id])
                                                        }} disabled={!item?.columnId?.name.toLowerCase().includes('progress')} />
                                                </div>
                                                <div className="task_list w-full">
                                                    <div className="task_list_item">
                                                        <div className="task_title text-black font-bold hover:underline cursor-pointer hover:text-blue-700" onClick={() => setSelectedTask(item._id)}>
                                                            {item.title}
                                                        </div>
                                                        <Space direction="horizontal" className="task_status">
                                                            <div className="task_Priority capitalize underline text-gray-500">
                                                                {item?.priority} Priority
                                                            </div>
                                                            <div>
                                                                |
                                                            </div>
                                                            <div className={`task_Priority text-[${item?.columnId?.color}]`}>
                                                                {item?.columnId?.name}
                                                            </div>
                                                        </Space>
                                                    </div>
                                                    <div className="task_dis_view">
                                                        <div className="w-full text-gray-600 line-clamp-2" dangerouslySetInnerHTML={{ __html: item?.description }} />
                                                    </div>
                                                </div>
                                            </div>}
                                    />
                                </div>
                            </Space>
                        </div>
                        <div className='mt-2 text-gray-500'>
                            You cannot select tasks that are not in progress. Please move the task to "In Progress" to select it for today.
                        </div>
                    </> : <>
                        <div className='mt-4 text-gray-500 text-center max-w-3xl mx-auto'>
                            <Empty description='Please select a project to view tasks' />
                        </div>
                    </>}
                </div>
            </CustomModal>

            <Modal
                title={null}
                open={selectedTask}
                onCancel={() => {
                    setSelectedTask(null)
                    setLoading(true)
                }}
                maskClosable={false}
                footer={null}
                width={'80%'}
            >
                <IssueComponent selectedTask={selectedTask} />
            </Modal>
        </div>
    );
};

export default TaskManagement;
